<template>
  <v-card class="pa-0 mx-auto" flat>
    <v-alert type="info" dense text class="mb-4">
      برای دانلود فایل نمونه اکسل
      <a :href="sampleImport" download class="font-weight-bold"
        >اینجا کلیک کنید</a
      >.
    </v-alert>

    <v-card
      id="uploader"
      ref="uploader"
      class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden drag-zone"
      height="200"
      outlined
      @click="openFileInput"
      @dragleave="dragEvent"
      @dragover="dragEvent"
      @drop="dragEvent"
    >
      <v-icon size="68" style="opacity: 0.4">mdi-file-excel-outline</v-icon>
      <v-card-title class="justify-center">آپلود فایل اکسل</v-card-title>
      <v-card-text class="text-center pt-0 text-break">
        فایل‌ اکسل (xlsx, xls) را اینجا رها کنید یا
        <v-btn class="mx-1" color="primary" min-width="75" small>
          کلیک کنید
        </v-btn>
        تا انتخاب شود.
      </v-card-text>
    </v-card>

    <input
      type="file"
      ref="fileInput"
      accept=".xlsx, .xls, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      class="d-none"
      @change="handleFileInputChange"
    />

    <v-card
      v-if="selectedFile"
      class="mt-3 mx-auto pa-1 rounded-lg"
      flat
      outlined
    >
      <div class="pa-1 text-center">
        <v-list-item>
          <v-list-item-avatar
            class="white--text"
            size="32"
            rounded
            color="green"
          >
            <v-icon dark>mdi-file-excel</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="selectedFile.name" class="text-right" />
            <v-list-item-subtitle
              class="text-right"
              v-text="formatSize(selectedFile.size)"
            />
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon color="error" @click.stop="removeFile">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "ExcelUploader",
  props: { sampleImport: String },
  data: () => ({
    selectedFile: null,
  }),
  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;

      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      ) {
        uploader.$el.classList.add("drag-over");
      } else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      ) {
        uploader.$el.classList.remove("drag-over");
      } else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.dataTransfer.files;
        this.processFile(files);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileInputChange(e) {
      const files = e.target.files;
      this.processFile(files);
      e.target.value = null;
    },
    processFile(files) {
      if (!files || files.length === 0) return;

      const file = files[0];
      const validExtensions = ["xlsx", "xls", "csv"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        this.$toast.error("لطفا فقط فایل اکسل انتخاب کنید.");
        return;
      }

      this.selectedFile = file;
      this.$emit("input", this.selectedFile);
    },
    removeFile() {
      this.selectedFile = null;
      this.$emit("input", null);
    },
    formatSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>

<style scoped>
.drag-zone {
  cursor: pointer;
  border: 2px dashed #ccc !important;
  transition: all 0.3s ease;
}
.drag-zone:hover,
.drag-over {
  background-color: #f0f8ff !important;
  border-color: #1976d2 !important;
}
</style>
